import { useEffect, useState } from "react";
import useFetch from "../../../hooks/useFetch";
import { Fichier } from "../../../services/Api/swagger";

export const useBulletinAdhesion = () => {
  const [launchBulletinNumero, setLaunchBulletinNumero] = useState<
    string | undefined
  >();
  const {
    response: responsePdf,
    fetching: fetchingPdf,
    error,
  } = useFetch<Fichier>(
    launchBulletinNumero,
    "getBulletinAdhesion",
    launchBulletinNumero ? true : false
  );
  useEffect(() => {
    if (responsePdf) {
      var byteCharacters = atob(responsePdf.content);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var file = new Blob([byteArray], { type: "application/pdf;base64" });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      setLaunchBulletinNumero(undefined);
    }
  }, [responsePdf]);

  return {
    responsePdf,
    fetchingPdf,
    error,
    setLaunchBulletinNumero,
  };
};
